import React, {useState, useEffect} from 'react';
import {deletePlan, patchNewPlan, undeletePlan} from './../requests';
import {connect} from 'react-redux';
import { useRouter } from 'next/router';
import {
    nextStep,
    ifloorplanStateAdd,
    setType,
    LibImageAdd,
    LibPlanAdd,
    panelumLib,
    clearIfloorState
} from '../../New/redux/actions/actions';
import { InlineShareButtons } from 'sharethis-reactjs';
import { getIfloorplan } from '../../Ifloorplan/serverRequests/requests';

const Plan = (props) => {
    const router = useRouter();
    const [staticUrl, setStaticUrl] = useState(props.currentUser.domain_api ? props.currentUser.domain_api : 
        (window.location.href.replace(router.pathname, '') + "/ifloorplan/"));
    const [brandingSelectValue, setBrandingSelectValue] = useState('');
    const [changedUrl, setChangedUrl] = useState(staticUrl + props.data.id);
    const [embedAction, setEmbedAction] = useState(false);
    const [shareActon, setShareAction] = useState(false);
    const [newState, setNewState] = useState(props.data);
    const [currentClient, setCurrentClient] = useState({});
    const [expireDays, setExpireDays] = useState(0);
    const [outOfCreditAlert, setOutOfCreditAlert] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    
    useEffect(() => {
        if(props.data.client_data && props.data.client_data !== '')
            setCurrentClient(JSON.parse(props.data.client_data));
    },[]);
    
    useEffect(() => {
        setChangedUrl(staticUrl + props.data.id);
    },[props.data]);

    useEffect(() => {
        const expired_time_sec = newState.end_live - parseInt(new Date().getTime() / 1000);
        const expired_time_days = parseInt(expired_time_sec / 60 / 60 / 24);
        setExpireDays(expired_time_days);
    }, [newState])


    const deletePlanObj = (id_plan) => {
        const data = {
            id: id_plan
        }
        setIsDeleted(true);
        deletePlan(data);
    }

    const undeletePlanObj = (id) => {
        const data = {
            id: id
        }
        setIsDeleted(false);
        undeletePlan(data)
        .then(res => {
            setNewState(res);
        })
    }

    const changeOption = (event) => {
        let origUrl = changedUrl.split('?')[0]
        setChangedUrl(origUrl+event.target.value);
    };

    const publish = () => {
        let new_state = JSON.parse(JSON.stringify(newState));
        if(!new_state.paid){
            new_state.paid = true;
        }
        new_state.published = true;
        new_state.start_live = parseInt(new Date().getTime() / 1000);
        new_state.end_live = parseInt(new Date().getTime() / 1000 + 365*24*3600);
        const planState = {
            id: new_state.id,
            paid: new_state.paid,
            published: new_state.published,
            first_published_datetime: new_state.first_published_datetime,
            end_live: new_state.end_live
        }
        patchNewPlan(planState).then(data => {
            (data);
            if (data){
                setNewState(data[0]);
                props.update();
            }
            else {
                setOutOfCreditAlert(true);
            }
        });
    }

    const unpublish = () => {
        const planState = {
            id: newState.id,
            published: false
        }
        patchNewPlan(planState).then(data => {
            setNewState(data[0])});
            props.update();
    }

    useEffect(() => {
        setNewState(props.data);
    }, [props.data])

    return (
        <div className="plan_wrap_item" id={props.data.id}>
            {/* {outOfCreditAlert ? <OutOfCredit setOutOfCreditAlert={setOutOfCreditAlert}/> : null} */}
            <div className="plan_item">
                    <div className="address"><h2>{newState.address}</h2></div>
                <div className="logo">
                    <img style={{width: "150px"}} src={newState.level[0]?.images[0]?.library_image?.image ? newState.level[0]?.images[0]?.library_image?.image : '/static/public/img/default_cover_image.jpeg'} alt=""/>
                    {newState.published ?
                    <p>Published | <span onClick={() => unpublish()} className='unpublish-button'>UnPublish</span></p>
                    : <div><p style={{color: 'red', display: 'inline'}}>Not Published &nbsp;</p> |
                    <span onClick={() => publish()} className='publish-button'>&nbsp; Publish now</span></div>}
                    <div className="credit-alert">
                            {outOfCreditAlert ? 
                            <>
                                <p style={{marginRight: '5px', color: '#f00'}}>You have no Credits</p>
                                <a href="/user/purchase" target="_blank"
                                    style={{marginLeft: '5px', color: '#0170B9'}}>Purchase credits</a>
                            </>
                            : ''}
                    </div>
                </div>
                <div className="tools">
                    <div className="address"><h2>{newState.address}</h2></div>
                    {!isDeleted ? <>
                        <div className="url_option">
                            <input type="text" value={changedUrl}
                            onFocus={(event) => event.target.select()}
                            onChange={(event) => {
                                event.preventDefault()
                            }}/>
                            <span className='copy-btn'
                            onClick={(e) => {
                                navigator.clipboard.writeText(changedUrl);
                                props.setCopiedUrl(changedUrl);
                            }}>
                                {props.copiedUrl === changedUrl ? "Link copied" : "Copy link"}
                            </span>
                            <select value={brandingSelectValue} onChange={event => {
                                setBrandingSelectValue(event.target.value);
                                changeOption(event);
                                }}>
                                <option value="">Show all branding</option>
                                <option value="?hb=1">Hide all branding</option>
                                <option value="?hbo=1">Hide my branding</option>
                                <option value="?hco=1">Hide client branding</option>
                            </select>
                        </div>
                        <div className="btn_group">
                            <a href={changedUrl} target="_blank">View</a>
                            <a href={"/user/edit/" + newState.id} onClick={() => {
                                unpublish();
                                props.setRefresh(true);
                            }} target="_blank"
                            className='edit-button'
                            >{newState.published ? `Unpublish & Edit` : 'Edit & Publish'}</a>
                            <a href="" onClick={(event) => {
                                event.preventDefault();
                                setShareAction(!shareActon);
                            }}>Share</a>
                            <a href="" onClick={(event) => {
                                event.preventDefault();
                                setEmbedAction(!embedAction);
                            }}>Embed</a>
                            <a className='delete-plan-button'
                                href="" onClick={(event) => {
                                    event.preventDefault();
                                    deletePlanObj(newState.id);
                                }}
                            >Delete</a>
                        </div>
                        {shareActon ? <div className="shareWrap">
                        <InlineShareButtons
                        config={{
                            alignment: 'center',  // alignment of buttons (left, center, right)
                            color: 'social',      // set the color of buttons (social, white)
                            enabled: true,        // show/hide buttons (true, false)
                            font_size: 16,        // font size for the buttons
                            labels: 'null',        // button labels (cta, counts, null)
                            language: 'en',       // which language to use (see LANGUAGES)
                            networks: [           // which networks to include (see SHARING NETWORKS)
                            'facebook',
                            'twitter',
                            'linkedin',
                            'messenger',
                            'email',
                            ],
                            padding: 12,          // padding within buttons (INTEGER)
                            radius: 4,            // the corner radius on each button (INTEGER)
                            show_total: true,
                            size: 30,             // the size of each button (INTEGER)

                            // OPTIONAL PARAMETERS
                            url: changedUrl,
                            image: staticUrl.replace('/ifloorplan/', props.data.splash_screen),  // (defaults to og:image or twitter:image)
                            description: 'This is my new iFloorPlan',       // (defaults to og:description or twitter:description)
                            title: 'Take a look around this property',            // (defaults to og:title or twitter:title)
                            message: changedUrl + ' \nClick the icons on the floor plan to see the image taken from that spot. \n',     // (only for email sharing)
                            subject: 'Take a look around this property',  // (only for email sharing)
                        }}
                        />
                        </div> : ""}
                        {embedAction ? <div className="embed">
                        <pre><code>&lt;iframe src={changedUrl} style="border: 0"
                                width="801" height="500" frameBorder="0"
                                scrolling="no"&gt;&lt;/iframe&gt;</code></pre>
                        </div> : ""}
                        <div className="info">
                            {newState.published ?
                            <div>Published | <span onClick={() => unpublish()} className='unpublish-button'>UnPublish</span></div>
                            : <div style={{display: 'inline-flex'}}><p style={{color: 'red'}}>Not Published &nbsp;</p> |
                            <span onClick={() => {
                                if (newState.id) {
                                    getIfloorplan(newState.id)
                                        .then((res)=>{
                                            setNewState(res[0]);
                                            if(!res[0]?.published){
                                                publish();
                                            }
                                        },
                                        (error) => {
                                            setError(true);
                                        })   
                                    }
                                }}
                                className='publish-button'
                            >&nbsp; Publish now</span></div>}
                            
                            <div className="credit-alert">
                                {outOfCreditAlert ? 
                                <>
                                    <p>You have no credit</p>
                                    |
                                    <a href="/user/purchase" target="_blank">Purchase credits</a>
                                </>
                                : ''}
                            </div>

                            <p className='expire'>
                                {newState.first_published_datetime && !newState.published ? `Expired` 
                                : `Expires in ${newState.published ? props.time : 0} days`} | Viewed {newState.published ? newState.viewed : 0} times
                            </p>
                        </div>
                        <div>{expireDays < 31 || !newState.published ? 
                            <>
                                <span style={{color :'red', float: 'right', cursor: 'default'}}>
                                    {!newState.published ? !newState.first_published_datetime ? `This un-published iFloorPlan will be deleted in ${props.time} days` : ''
                                    : `This iFloorPlan will expire in ${props.time} days`}
                                </span>
                                {!newState.published ? '' : 
                                    <p style={{color :'#0170B9', float :'right', marginRight: '3%', cursor: 'pointer'}}
                                        onClick={(e) => publish()}>
                                        Republish now
                                    </p>}
                                {/* <span style={{float: 'right', marginTop: '-2%', marginRight: '-58%'}}>
                                    Publish Permanently</span> */}
                            </>
                            // : <span style={{float: 'right', marginTop: '-2%', marginRight: '-22%'}}>
                            //     Publish Permanently</span>
                            :''}
                        </div>
                    </>
                    :
                    <div className='undelete-button'>
                        <a href="" 
                            onClick={(event) => {
                                event.preventDefault();
                                undeletePlanObj(newState.id);
                            }}>
                            Undelete
                        </a>
                    </div>}
                </div> 
                <div style= {{height: '100%'}} className="brand_title">{currentClient.client_name}</div>
            </div>
            {/*{props.active ? <div className="editWrap"><NewOrTemp/></div> : ""}*/}
        </div>
    )
}
const putState = (state) => {
    return {
        step: state.step
    }
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
        LibPlanAdd: (array) => dispatch(LibPlanAdd(array)),
        LibImageAdd: (array) => dispatch(LibImageAdd(array)),
        panelumLib: (items) => dispatch(panelumLib(items)),
        setType: (key) => dispatch(setType(key)),
        clearIfloorState: () => dispatch(clearIfloorState())
    }
}


export default connect(putState, putActions)(Plan);
